import ExcelExport from '@vzmi/component_ec_nodejs_util/dist/lib/ExcelExportWithStyle'

export const getExcelExport = async () => {
  const asyncPkg = await ExcelExport
  const ExcelExportWithStyle = await asyncPkg
  return ExcelExportWithStyle
}
